import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-addemppop',
  templateUrl: './addemppop.component.html',
  styleUrls: ['./addemppop.component.css']
})
export class AddemppopComponent implements OnInit {


  constructor(private toastr: ToastrService,private appService: AppdataService,private datePipe: DatePipe,
    public loginService:LoginserviceService,private activeModal: NgbActiveModal,private confirmationDialogService: ConfirmationDialogService) { }

  
//Save Validation
submitted:boolean;
successfully:boolean;
     
empform=new FormGroup({
    empid:new FormControl(0),          
    empcode:new FormControl('',Validators.required),  
    empname:new FormControl('',Validators.required),  
    fathername:new FormControl(''),     
    mothername:new FormControl(''),  
    spousename:new FormControl(''),  
    presentaddress:new FormControl(''),  
    mobile:new FormControl(''),  
    altmobile:new FormControl(''),  
    permanantaddress:new FormControl(''),  
    permcontactnum:new FormControl(''),  
    relationname:new FormControl(''),  
    relationmobile:new FormControl(''),  
    emailid:new FormControl(''),  
    staffcode:new FormControl('',Validators.required),  
    lastname:new FormControl(''),  
    personalemailid:new FormControl(''),  
    recommandby:new FormControl(''),  
    remarks:new FormControl(''),  
    passportnumber:new FormControl(''),  
    visanumber:new FormControl(''),  
    emiratesid:new FormControl(''),  
    bankaccno:new FormControl(''),  
    iban:new FormControl(''),  
    labourid:new FormControl(''),  
    personcode:new FormControl(''),
    accomdetails:new FormControl(''),
    joindt:new FormControl(''),  
    probationdt:new FormControl(''),  
    relievedt:new FormControl(''),  
    dob:new FormControl(''),  
    confirmdt:new FormControl(''),  
    passportexpdt:new FormControl(''),  
    visaexpdt:new FormControl(''),  
    emiratesidexpdt:new FormControl(''),      
    labourexpdt:new FormControl(''),      
    genderid:new FormControl(null),  
    maritalstatusid:new FormControl(null),  
    nationalityid:new FormControl(null),  
    relationshipid:new FormControl(null),  
    paymodeid:new FormControl(null),  
    payrollgrpid:new FormControl(null),  
    emptypeid:new FormControl(null),  
    relievetypeid:new FormControl(null),  
    departmentid:new FormControl(null),  
    designationid:new FormControl(null),  
    gradeid:new FormControl(null),  
    branchid:new FormControl(null),      
    locationid:new FormControl(null), 
    religionid:new FormControl(null), 
    bloodgroupid:new FormControl(null), 
    sponserid:new FormControl(null), 
    contracttypeid:new FormControl(null),
    categoryid:new FormControl(null),
    paytypeid:new FormControl(null),
    wpsgroupid:new FormControl(null),
    bankid:new FormControl(null),
    reportingmanagerid:new FormControl(null),
    approvalmanagerid:new FormControl(null),
    noticeperiod:new FormControl(null),
    statusid:new FormControl(null),
    leavepolicyid:new FormControl(null),   
    salutionid:new FormControl(null),   
    hiresourceid:new FormControl(null),   
    accomtypeid:new FormControl(null),   
    emppic:new FormControl(''), 
    empimage:new FormControl(null),    
    inactive:new FormControl(false),  
  });

//Edit Get Values
empColl: any = [];
empBO:any={};
empid: number = 0
  
 //Master
 genderColl:any=[];
 maritalstatusColl:any=[];
 nationalityColl:any=[];
 relationshipColl:any=[];
 paymodeColl:any=[];
 payrollgrpColl:any=[];
 emptypeColl:any=[];
 relievetypeColl:any=[];
 departmentColl:any=[];
 designationColl:any=[];
 gradeColl:any=[];
 branchColl:any=[];
 locationColl:any=[];

 religionColl:any=[];
 bloodgroupColl:any=[];
 sponserColl:any=[];
 contracttypeColl:any=[];
 categoryColl:any=[];
 paytypeColl:any=[];
 wpsgroupColl:any=[];
 bankColl:any=[];
 reportingmanagerColl:any=[];
 approvalmanagerColl:any=[];
 statusColl:any=[];
 leavepolicyColl:any=[];
 accomtypeColl:any=[];
 salutionColl:any=[];
 hiresourceColl:any=[];

@Input() empformtype:string="";
@Input() strImage: any;
@Input() picurl:string="";


@Output() emitData = new EventEmitter();


  ngOnInit() {

    this.empform.reset();
    this.fnInitializeFormGroup(); 

    this.fnLoadMaster();
  }

  fnInitializeFormGroup(){
    this.empform.setValue({
      empid:0,    
      empcode:'New',
      empname:'',
      fathername:'',     
      mothername:'',  
      spousename:'',  
      presentaddress:'',  
      mobile:'',  
      altmobile:'',  
      permanantaddress:'',  
      permcontactnum:'',  
      relationname:'',  
      relationmobile:'',  
      emailid:'',  
      staffcode:'',  
      lastname:'',  
      personalemailid:'',  
      recommandby:'',  
      remarks:'',  
      passportnumber:'',  
      visanumber:'',  
      emiratesid:'',  
      bankaccno:'',  
      iban:'',  
      labourid:'',  
      personcode:'', 
      accomdetails:'',
      joindt:null,  
      probationdt:null,  
      relievedt:null,  
      dob:null,  
      confirmdt:null,  
      passportexpdt:null,  
      visaexpdt:null,  
      emiratesidexpdt:null,
      labourexpdt:null,
      genderid:null,  
      maritalstatusid:null,  
      nationalityid:null,  
      relationshipid:null,  
      paymodeid:null,  
      payrollgrpid:null,  
      emptypeid:null,  
      relievetypeid:null,  
      departmentid:null,  
      designationid:null,
      gradeid:null,  
      branchid:null,      
      locationid:null,
      religionid:null, 
      bloodgroupid:null, 
      sponserid:null, 
      contracttypeid:null,
      categoryid:null,
      paytypeid:null,
      wpsgroupid:null,
      bankid:null,
      reportingmanagerid:null,
      approvalmanagerid:null,
      noticeperiod:null,
      statusid:null,
      leavepolicyid:null,
      salutionid:null,
      hiresourceid:null,
      accomtypeid:null,
      emppic:'',
      empimage:null,
      inactive:false              
    })
  }

  fnLoadMaster(){
    this.fngetGender();
    this.fngetMaritalStatus();
    this.fngetRelationship();
    this.fngetPaymode();
    this.fngetPayrollgrp();
    this.fngetEmpType();
    this.fngetRelieveType();
    this.fngetDesignation();
    this.fngetDepartment();
    this.fngetGrade();
    this.fngetBranch();
    this.fngetLocation();
    this.fngetNationality();
    this.fngetRegion();
    this.fngetBloodGroup();
    this.fngetSponser();
    this.fngetContractType();
    this.fngetCategory();
    this.fngetPayType();
    this.fngetWpsGroup();
    this.fngetBank();
    this.fngetReportingManager();
    this.fngetApprovalManager();
    this.fngetStatus();
    this.fngetLeavePolicy();
    this.fngetAccomType();
    this.fngetHiResource();
    this.fngetSalution();
  }


  //Get Master
  fngetGender() {   
    var data = {
        'genderid':0,
        'companyid': this.loginService.fnGetCompanyId(),            
    }
    this.appService.getGender(data)
    .subscribe(
        (res)=>{                  
          if(res.json().status===200){
              this.genderColl=res.json().result;                    
          }else {
              this.loginService.fnAPIError(res.json())
          }             
        },
        (err)=>{          
            this.toastr.error('Error', err);
    })
  }

  fngetMaritalStatus() {   
    var data = {
        'maritalstatusid':0,
        'companyid': this.loginService.fnGetCompanyId(),            
    }
    this.appService.getMaritalStatus(data)
    .subscribe(
        (res)=>{                  
          if(res.json().status===200){
              this.maritalstatusColl=res.json().result;                    
          }else {
              this.loginService.fnAPIError(res.json())
          }             
        },
        (err)=>{          
            this.toastr.error('Error', err);
    })
  }

  fngetRelationship() {   
    var data = {
        'relationshipid':0,
        'companyid': this.loginService.fnGetCompanyId(),            
    }
    this.appService.getRelationship(data)
    .subscribe(
        (res)=>{                  
          if(res.json().status===200){
              this.relationshipColl=res.json().result;                    
          }else {
              this.loginService.fnAPIError(res.json())
          }             
        },
        (err)=>{          
            this.toastr.error('Error', err);
    })
  }

  fngetPaymode() {   
    var data = {
        'paymodeid':0,
        'companyid': this.loginService.fnGetCompanyId(),            
    }
    this.appService.getPayMode(data)
    .subscribe(
        (res)=>{                  
          if(res.json().status===200){
              this.paymodeColl=res.json().result;                    
          }else {
              this.loginService.fnAPIError(res.json())
          }             
        },
        (err)=>{          
            this.toastr.error('Error', err);
    })
  }

  fngetPayrollgrp() {   
    var data = {
        'payrollgrpid':0,
        'companyid': this.loginService.fnGetCompanyId(),            
    }
    this.appService.getPayrollgrp(data)
    .subscribe(
        (res)=>{                  
          if(res.json().status===200){
              this.payrollgrpColl=res.json().result;                    
          }else {
              this.loginService.fnAPIError(res.json())
          }             
        },
        (err)=>{          
            this.toastr.error('Error', err);
    })
  }
  
  fngetEmpType() {   
    var data = {
        'emptypeid':0,
        'companyid': this.loginService.fnGetCompanyId(),            
    }
    this.appService.getEmpType(data)
    .subscribe(
        (res)=>{                  
          if(res.json().status===200){
              this.emptypeColl=res.json().result;                    
          }else {
              this.loginService.fnAPIError(res.json())
          }             
        },
        (err)=>{          
            this.toastr.error('Error', err);
    })
  }

  fngetRelieveType() {   
    var data = {
        'relievetypeid':0,
        'companyid': this.loginService.fnGetCompanyId(),            
    }
    this.appService.getRelieveType(data)
    .subscribe(
        (res)=>{                  
          if(res.json().status===200){
              this.relievetypeColl=res.json().result;                    
          }else {
              this.loginService.fnAPIError(res.json())
          }             
        },
        (err)=>{          
            this.toastr.error('Error', err);
    })
  }

  fngetDepartment() {   
    var data = {
        'departmentid':0,
        'companyid': this.loginService.fnGetCompanyId(),            
    }
    this.appService.getDepartment(data)
    .subscribe(
        (res)=>{                  
          if(res.json().status===200){
              this.departmentColl=res.json().result;                    
          }else {
              this.loginService.fnAPIError(res.json())
          }             
        },
        (err)=>{          
            this.toastr.error('Error', err);
    })
  }

  fngetDesignation() {   
    var data = {
        'designationid':0,
        'companyid': this.loginService.fnGetCompanyId(),            
    }
    this.appService.getDesignation(data)
    .subscribe(
        (res)=>{                  
          if(res.json().status===200){
              this.designationColl=res.json().result;                            
          }else {
              this.loginService.fnAPIError(res.json())
          }             
        },
        (err)=>{          
            this.toastr.error('Error', err);
    })
  }


  fngetGrade() {   
    var data = {
        'gradeid':0,
        'companyid': this.loginService.fnGetCompanyId(),            
    }
    this.appService.getGrade(data)
    .subscribe(
        (res)=>{                  
          if(res.json().status===200){
              this.gradeColl=res.json().result;                    
          }else {
              this.loginService.fnAPIError(res.json())
          }             
        },
        (err)=>{          
            this.toastr.error('Error', err);
    })
  }

  fngetBranch() {   
    var data = {
        'branchid':0,
        'companyid': this.loginService.fnGetCompanyId(),            
    }
    this.appService.getBranch(data)
    .subscribe(
        (res)=>{                  
          if(res.json().status===200){
              this.branchColl=res.json().result;                    
          }else {
              this.loginService.fnAPIError(res.json())
          }             
        },
        (err)=>{          
            this.toastr.error('Error', err);
    })
  }

  fngetLocation() {   
    var data = {
        'locationid':0,
        'companyid': this.loginService.fnGetCompanyId(),            
    }
    this.appService.getLocation(data)
    .subscribe(
        (res)=>{                  
          if(res.json().status===200){
              this.locationColl=res.json().result;                    
          }else {
              this.loginService.fnAPIError(res.json())
          }             
        },
        (err)=>{          
            this.toastr.error('Error', err);
    })
  }

  fngetNationality() {   
    var data = {
        'nationalityid':0,
        'companyid': this.loginService.fnGetCompanyId(),            
    }
    this.appService.getNationality(data)
    .subscribe(
        (res)=>{                  
          if(res.json().status===200){
              this.nationalityColl=res.json().result;                    
          }else {
              this.loginService.fnAPIError(res.json())
          }             
        },
        (err)=>{          
            this.toastr.error('Error', err);
    })
  }


  fngetRegion() {   
    var data = {
        'religionid':0,
        'companyid': this.loginService.fnGetCompanyId(),            
    }
    this.appService.getReligion(data)
    .subscribe(
        (res)=>{                  
          if(res.json().status===200){
              this.religionColl=res.json().result;                    
          }else {
              this.loginService.fnAPIError(res.json())
          }             
        },
        (err)=>{          
            this.toastr.error('Error', err);
    })
  }

  fngetBloodGroup() {   
    var data = {
        'bloodgroupid':0,
        'companyid': this.loginService.fnGetCompanyId(),            
    }
    this.appService.getBloodGroup(data)
    .subscribe(
        (res)=>{                  
          if(res.json().status===200){
              this.bloodgroupColl=res.json().result;                    
          }else {
              this.loginService.fnAPIError(res.json())
          }             
        },
        (err)=>{          
            this.toastr.error('Error', err);
    })
  }

  fngetSponser() {   
    var data = {
        'sponserid':0,
        'companyid': this.loginService.fnGetCompanyId(),            
    }
    this.appService.getSponser(data)
    .subscribe(
        (res)=>{                  
          if(res.json().status===200){
              this.sponserColl=res.json().result;                    
          }else {
              this.loginService.fnAPIError(res.json())
          }             
        },
        (err)=>{          
            this.toastr.error('Error', err);
    })
  }

  fngetContractType() {   
    var data = {
        'contracttypeid':0,
        'companyid': this.loginService.fnGetCompanyId(),            
    }
    this.appService.getContractType(data)
    .subscribe(
        (res)=>{                  
          if(res.json().status===200){
              this.contracttypeColl=res.json().result;                    
          }else {
              this.loginService.fnAPIError(res.json())
          }             
        },
        (err)=>{          
            this.toastr.error('Error', err);
    })
  }

  fngetCategory() {   
    var data = {
        'categoryid':0,
        'companyid': this.loginService.fnGetCompanyId(),            
    }
    this.appService.getCategory(data)
    .subscribe(
        (res)=>{                  
          if(res.json().status===200){
              this.categoryColl=res.json().result;                    
          }else {
              this.loginService.fnAPIError(res.json())
          }             
        },
        (err)=>{          
            this.toastr.error('Error', err);
    })
  }

  fngetPayType() {   
    var data = {
        'paytypeid':0,
        'companyid': this.loginService.fnGetCompanyId(),            
    }
    this.appService.getPayType(data)
    .subscribe(
        (res)=>{                  
          if(res.json().status===200){
              this.paytypeColl=res.json().result;                    
          }else {
              this.loginService.fnAPIError(res.json())
          }             
        },
        (err)=>{          
            this.toastr.error('Error', err);
    })
  }

  fngetWpsGroup() {   
    var data = {
        'wpsgroupid':0,
        'companyid': this.loginService.fnGetCompanyId(),            
    }
    this.appService.getWpsGroup(data)
    .subscribe(
        (res)=>{                  
          if(res.json().status===200){
              this.wpsgroupColl=res.json().result;                    
          }else {
              this.loginService.fnAPIError(res.json())
          }             
        },
        (err)=>{          
            this.toastr.error('Error', err);
    })
  }
  
  fngetBank() {   
    var data = {
        'bankid':0,
        'companyid': this.loginService.fnGetCompanyId(),            
    }
    this.appService.getBank(data)
    .subscribe(
        (res)=>{                  
          if(res.json().status===200){
              this.bankColl=res.json().result;                    
          }else {
              this.loginService.fnAPIError(res.json())
          }             
        },
        (err)=>{          
            this.toastr.error('Error', err);
    })
  }
  
  fngetReportingManager() {   
    var data = {
        'empid':0,
        'companyid': this.loginService.fnGetCompanyId(),            
    }
    this.appService.getEmpListView(data)
    .subscribe(
        (res)=>{                  
          if(res.json().status===200){
              this.reportingmanagerColl=res.json().result;                    
          }else {
              this.loginService.fnAPIError(res.json())
          }             
        },
        (err)=>{          
            this.toastr.error('Error', err);
    })
  }

  fngetApprovalManager() {   
    var data = {
        'empid':0,
        'companyid': this.loginService.fnGetCompanyId(),            
    }
    this.appService.getEmpListView(data)
    .subscribe(
        (res)=>{                  
          if(res.json().status===200){
              this.approvalmanagerColl=res.json().result;                    
          }else {
              this.loginService.fnAPIError(res.json())
          }             
        },
        (err)=>{          
            this.toastr.error('Error', err);
    })
  }
    
  fngetStatus() {   
    var data = {
        'statusid':0,
        'companyid': this.loginService.fnGetCompanyId(),            
    }
    this.appService.getStatus(data)
    .subscribe(
        (res)=>{                  
          if(res.json().status===200){
              this.statusColl=res.json().result;                    
          }else {
              this.loginService.fnAPIError(res.json())
          }             
        },
        (err)=>{          
            this.toastr.error('Error', err);
    })
  }

  fngetLeavePolicy() {   
    var data = {
        'leavepolicyid':0,
        'companyid': this.loginService.fnGetCompanyId(),            
    }
    this.appService.getLeavePolicy(data)
    .subscribe(
        (res)=>{                  
          if(res.json().status===200){
              this.leavepolicyColl=res.json().result;                    
          }else {
              this.loginService.fnAPIError(res.json())
          }             
        },
        (err)=>{          
            this.toastr.error('Error', err);
    })
  }

  fngetAccomType() {   
    var data = {
        'accomtypeid':0,
        'companyid': this.loginService.fnGetCompanyId(),            
    }
    this.appService.getAccomType(data)
    .subscribe(
        (res)=>{                  
          if(res.json().status===200){
              this.accomtypeColl=res.json().result;                    
          }else {
              this.loginService.fnAPIError(res.json())
          }             
        },
        (err)=>{          
            this.toastr.error('Error', err);
    })
  }


  fngetHiResource() {   
    var data = {
        'hiresourceid':0,
        'companyid': this.loginService.fnGetCompanyId(),            
    }
    this.appService.getHiResource(data)
    .subscribe(
        (res)=>{                  
          if(res.json().status===200){
              this.hiresourceColl=res.json().result;                    
          }else {
              this.loginService.fnAPIError(res.json())
          }             
        },
        (err)=>{          
            this.toastr.error('Error', err);
    })
  }


  fngetSalution() {   
    var data = {
        'salutionid':0,
        'companyid': this.loginService.fnGetCompanyId(),            
    }
    this.appService.getSalution(data)
    .subscribe(
        (res)=>{                  
          if(res.json().status===200){
              this.salutionColl=res.json().result;    
              if(this.empid===0 && this.salutionColl.length){
                this.empform.patchValue({ salutionid:this.salutionColl[0].salutionid});

              }
              
          }else {
              this.loginService.fnAPIError(res.json())
          }             
        },
        (err)=>{          
            this.toastr.error('Error', err);
    })
  }  
  
  
//Get 
fngetEmp() {        
  var data = {
    'empid':this.empid,
    'companyid':this.loginService.fnGetCompanyId()          
  }
  this.appService.getEmp(data)
  .subscribe(
    (res)=>{                
      if(res.json().status===200){  
        var _res=res.json().result;
        this.empColl=_res[0];
        
        var editdata = this.empColl[0];        
        this.fnEditMode(editdata);
      }
      else {
        this.loginService.fnAPIError(res.json())
      }
      
  },
  (err)=>{          
    this.toastr.error('Error', err);
  })
}

  
private fnEditMode(deptBO){
  deptBO.joindt=this.fnConvertDatetime(this.fnFormatDatetime(deptBO.joindt));
  deptBO.probationdt=this.fnConvertDatetime(this.fnFormatDatetime(deptBO.probationdt));
  deptBO.relievedt=this.fnConvertDatetime(this.fnFormatDatetime(deptBO.relievedt));
  deptBO.dob=this.fnConvertDatetime(this.fnFormatDatetime(deptBO.dob));
  deptBO.confirmdt=this.fnConvertDatetime(this.fnFormatDatetime(deptBO.confirmdt));
  deptBO.passportexpdt=this.fnConvertDatetime(this.fnFormatDatetime(deptBO.passportexpdt));
  deptBO.visaexpdt=this.fnConvertDatetime(this.fnFormatDatetime(deptBO.visaexpdt));
  deptBO.emiratesidexpdt=this.fnConvertDatetime(this.fnFormatDatetime(deptBO.emiratesidexpdt));
  deptBO.labourexpdt=this.fnConvertDatetime(this.fnFormatDatetime(deptBO.labourexpdt));
  
  this.empform.patchValue({ 
    empid:deptBO.empid,     
    empcode:deptBO.empcode,
    empname:deptBO.empname,
    fathername:deptBO.fathername,     
    mothername:deptBO.mothername,  
    spousename:deptBO.spousename,  
    presentaddress:deptBO.presentaddress,  
    mobile:deptBO.mobile,  
    altmobile:deptBO.altmobile,  
    permanantaddress:deptBO.permanantaddress,  
    permcontactnum:deptBO.permcontactnum,  
    relationname:deptBO.relationname,  
    relationmobile:deptBO.relationmobile,  
    emailid:deptBO.emailid,  
    staffcode:deptBO.staffcode,  
    lastname:deptBO.lastname,  
    personalemailid:deptBO.personalemailid,  
    recommandby:deptBO.recommandby,  
    remarks:deptBO.remarks,  
    passportnumber:deptBO.passportnumber,  
    visanumber:deptBO.visanumber,  
    emiratesid:deptBO.emiratesid,  
    bankaccno:deptBO.bankaccno,  
    iban:deptBO.iban,  
    labourid:deptBO.labourid,  
    personcode:deptBO.personcode,  
    accomdetails:deptBO.accomdetails,      
    joindt:deptBO.joindt,  
    probationdt:deptBO.probationdt,  
    relievedt:deptBO.relievedt,
    dob:deptBO.dob,  
    confirmdt:deptBO.confirmdt,  
    passportexpdt:deptBO.passportexpdt,  
    visaexpdt:deptBO.visaexpdt,  
    emiratesidexpdt:deptBO.emiratesidexpdt,  
    labourexpdt:deptBO.labourexpdt,
    genderid:deptBO.genderid,  
    maritalstatusid:deptBO.maritalstatusid,  
    nationalityid:deptBO.nationalityid,  
    relationshipid:deptBO.relationshipid,  
    paymodeid:deptBO.paymodeid,  
    payrollgrpid:deptBO.payrollgrpid,  
    emptypeid:deptBO.emptypeid,  
    relievetypeid:deptBO.relievetypeid,  
    departmentid:deptBO.departmentid,  
    designationid:deptBO.designationid,  
    gradeid:deptBO.gradeid,  
    branchid:deptBO.branchid,      
    locationid:deptBO.locationid,
    religionid:deptBO.religionid, 
    bloodgroupid:deptBO.bloodgroupid, 
    sponserid:deptBO.sponserid, 
    contracttypeid:deptBO.contracttypeid,
    categoryid:deptBO.categoryid,
    paytypeid:deptBO.paytypeid,
    wpsgroupid:deptBO.wpsgroupid,
    bankid:deptBO.bankid,
    reportingmanagerid:deptBO.reportingmanagerid,
    approvalmanagerid:deptBO.approvalmanagerid,
    noticeperiod:deptBO.noticeperiod,
    statusid:deptBO.statusid,
    leavepolicyid:deptBO.leavepolicyid,
    salutionid:deptBO.salutionid,
    hiresourceid:deptBO.hiresourceid,
    accomtypeid:deptBO.accomtypeid,
    inactive:false
  });
 
}


  
  
fnSaveBtnClick(){
try{
  this.submitted=true;
  this.successfully=false;
  //Validate
  if(this.empform.valid){
    
      //Check
      var data = {
        empid: this.empid,                      
        empcode:this.empform.get('empcode').value, 
        empname:this.empform.get('empname').value, 
        fathername:this.empform.get('fathername').value,     
        mothername:this.empform.get('mothername').value,  
        spousename:this.empform.get('spousename').value,  
        presentaddress:this.empform.get('presentaddress').value,  
        mobile:this.empform.get('mobile').value,  
        altmobile:this.empform.get('altmobile').value,  
        permanantaddress:this.empform.get('permanantaddress').value,  
        permcontactnum:this.empform.get('permcontactnum').value,  
        relationname:this.empform.get('relationname').value,  
        relationmobile:this.empform.get('relationmobile').value,  
        emailid:this.empform.get('emailid').value,  
        staffcode:this.empform.get('staffcode').value,  
        lastname:this.empform.get('lastname').value,  
        personalemailid:this.empform.get('personalemailid').value,  
        recommandby:this.empform.get('recommandby').value,  
        remarks:this.empform.get('remarks').value,  
        passportnumber:this.empform.get('passportnumber').value,  
        visanumber:this.empform.get('visanumber').value,  
        emiratesid:this.empform.get('emiratesid').value,  
        bankaccno:this.empform.get('bankaccno').value,  
        iban:this.empform.get('iban').value,  
        labourid:this.empform.get('labourid').value,  
        personcode:this.empform.get('personcode').value,
        accomdetails:this.empform.get('accomdetails').value,    
        joindt:this.fnFormatDatetime(this.empform.get('joindt').value),  
        probationdt:this.fnFormatDatetime(this.empform.get('probationdt').value),  
        relievedt:this.fnFormatDatetime(this.empform.get('relievedt').value),  
        dob:this.fnFormatDatetime(this.empform.get('dob').value),  
        confirmdt:this.fnFormatDatetime(this.empform.get('confirmdt').value),  
        passportexpdt:this.fnFormatDatetime(this.empform.get('passportexpdt').value),  
        visaexpdt:this.fnFormatDatetime(this.empform.get('visaexpdt').value),  
        emiratesidexpdt:this.fnFormatDatetime(this.empform.get('emiratesidexpdt').value),  
        labourexpdt:this.fnFormatDatetime(this.empform.get('labourexpdt').value), 
        genderid:this.empform.get('genderid').value,  
        maritalstatusid:this.empform.get('maritalstatusid').value,  
        nationalityid:this.empform.get('nationalityid').value,  
        relationshipid:this.empform.get('relationshipid').value,  
        paymodeid:this.empform.get('paymodeid').value,  
        payrollgrpid:this.empform.get('payrollgrpid').value,  
        emptypeid:this.empform.get('emptypeid').value,  
        relievetypeid:this.empform.get('relievetypeid').value,  
        designationid:this.empform.get('designationid').value,  
        departmentid:this.empform.get('departmentid').value,  
        gradeid:this.empform.get('gradeid').value,  
        branchid:this.empform.get('branchid').value,      
        locationid:this.empform.get('locationid').value,
        religionid:this.empform.get('religionid').value, 
        bloodgroupid:this.empform.get('bloodgroupid').value, 
        sponserid:this.empform.get('sponserid').value, 
        contracttypeid:this.empform.get('contracttypeid').value,
        categoryid:this.empform.get('categoryid').value,
        paytypeid:this.empform.get('paytypeid').value,
        wpsgroupid:this.empform.get('wpsgroupid').value,
        bankid:this.empform.get('bankid').value,
        reportingmanagerid:this.empform.get('reportingmanagerid').value,
        approvalmanagerid:this.empform.get('approvalmanagerid').value,
        noticeperiod:this.empform.get('noticeperiod').value,
        statusid:this.empform.get('statusid').value,
        leavepolicyid:this.empform.get('leavepolicyid').value,
        salutionid:this.empform.get('salutionid').value, 
        hiresourceid:this.empform.get('hiresourceid').value, 
        accomtypeid:this.empform.get('accomtypeid').value, 
        empimage: this.strImage,
        emppic: this.picurl,    
        inactive:this.empform.get('inactive').value,            
        companyid:this.loginService.fnGetCompanyId(),      
      }


      this.appService.fnCheckEmp(data).subscribe(
      (res)=>{
      if(res.json().status===200){  
        var _checkresult=res.json().result[0].checkfield;

        if(_checkresult==="done"){
              if (this.empform.get('empid').value>0){
                //Update 
                this.fnSetEmp(data);
              }              
        }
        else{                         
           if(_checkresult==="name"){
             this.empform.controls['staffcode'].setErrors({'notfound': true});
           }
        }
      }
      else {
        this.loginService.fnAPIError(res.json())
      }
      },
      (err)=>{
      this.toastr.error('Error', err);           
      });
  }

}catch(ex){
this.fnShowErrorMsg(ex);
}
}

   
  //Set
  fnSetEmp(data){    
  
    this.appService.fnSetEmpPop(data).subscribe(
      (res)=>{
        if(res.json().status===200){  
              if(res.json().result!=""){
                this.emitData.emit("DONE");  
                this.activeModal.close(true);   
              } 
          }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err)=>{
        this.toastr.error('Error', err);
      });
    
    }
  
  


public decline() {
this.activeModal.close(false);
}

  
fnFormatDatetime(dt){
  if(dt){
    if(dt===""){
      return null
    }
    else{
      return this.datePipe.transform(dt,"yyyy-MM-dd")  
    }
    
    }else {
    return null
  }
  
}

fnConvertDatetime(dt){
  if(dt){
    if(dt===""){
      return null
    }
    else{
      var dateParts = dt.split("-");
      var sdate =new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2]+1); 
      sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
      return sdate;
    }
    
    }else {
    return null
  }
 
}
  

private  fnShowErrorMsg(ex){
  this.toastr.warning('Internal Error', ex);       
}




}
